// extracted by mini-css-extract-plugin
module.exports = {"box":"ContactPersonBox_box__kwhXl"};